<div [formGroup]="form">
  <div>
    <div class="option-selection">
      <mat-radio-group formControlName="addressType">
        <mat-radio-button value="postcode">Postcode</mat-radio-button>
        <mat-radio-button value="meterNo">Meter Number</mat-radio-button>
      </mat-radio-group>
    </div>
    
    <!-- Postcode Search -->
    @if (form.get('addressType')?.value === 'postcode') {
      <div formGroupName="addressSearch">
        <div class="search-section">
          <mat-form-field>
            <mat-label>Enter postcode</mat-label>
            <input matInput formControlName="postcode" placeholder="e.g. SE12 3LA"/>
            @if (form.get('addressSearch.postcode')?.errors?.['required']) {
              <mat-error>
                Postcode is required
              </mat-error>
            }
          </mat-form-field>
          
          <button mat-flat-button color="primary" (click)="searchPostcode()" 
                  [disabled]="!form.get('addressSearch.postcode')?.valid">
            Search
          </button>
        </div>
        
        @if (fetchingAddressLines) {
          <div class="progress-indicator">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        
        @if (addressList.length > 0) {
          <div class="address-selection">
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Choose your address</mat-label>
              <mat-select formControlName="address" (selectionChange)="onAddressSelected()">
                @for (address of addressList; track address.addressId) {
                  <mat-option [value]="address.addressId">
                    {{ address.addressAsLine }}
                  </mat-option>
                }
              </mat-select>
              <mat-hint>By selecting your address, you are consenting to us retrieving the meter details at your property</mat-hint>
            </mat-form-field>
          </div>
        }
      </div>
    }
    
    <!-- Meter Number Search -->
    @if (form.get('addressType')?.value === 'meterNo') {
      <div formGroupName="meterNoSearch">
        <div class="fuel-type-selection">
          <mat-label>Fuel Type</mat-label>
          <mat-radio-group formControlName="fuelType" class="fuel-type-radio-group">
            <mat-radio-button [value]="fuelTypeEnum.ELEC">Electricity</mat-radio-button>
            <mat-radio-button [value]="fuelTypeEnum.GAS">Gas</mat-radio-button>
          </mat-radio-group>
          @if (form.get('meterNoSearch.fuelType')?.errors?.['required']) {
            <mat-error>
              Fuel type is required
            </mat-error>
          }
        </div>
        <div class="search-section">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Enter Meter Number</mat-label>
            <input matInput formControlName="meterNo" placeholder="e.g. 1234567890123"/>
            <mat-hint>By entering your Meter Number, you are consenting to us retrieving additional meter details for this meter</mat-hint>
            @if (form.get('meterNoSearch.meterNo')?.errors?.['required']) {
              <mat-error>
                Meter number is required
              </mat-error>
            }
          </mat-form-field>
          
          <button mat-flat-button color="primary" (click)="searchMeterNo()" 
                  [disabled]="!form.get('meterNoSearch.meterNo')?.valid || !form.get('meterNoSearch.fuelType')?.valid">
            Search
          </button>
        </div>
      </div>
    }
    
    @if (fetchingMeterDetails) {
      <div class="progress-indicator">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
    
    @if (!fetchingMeterDetails && meterDetails.length > 0) {
      <div class="verification-section">                       
        <!-- Show supported meters only (HH) -->
       <!-- DEBUG:: {{ hasNonSupportedMeters() }} -->
        @if (getSupportedMeters().length === 1) {
          <div class="verification-text">
            <mat-icon class="verify-icon icon-no-shrink">check_circle</mat-icon>
            <span class="text-success">
                {{ getSupportedMeters()[0].meterType }} - {{ getSupportedMeters()[0].meterNo }} ({{ getSupportedMeters()[0].fuelType }}) at {{ getSupportedMeters()[0].addressAsLine }}.
            </span>
          </div>
        }
        @if (getSupportedMeters().length > 1) {
          <div>
            <h6>Multiple meters found. Please select one or more:</h6>

            <app-checkbox-group
              formControlName="selectedMeter"
              [options]="getMeterCheckboxOptions()"
              (checkboxChange)="onMeterCheckboxChange($event)">
            </app-checkbox-group>
          </div>
        }
      </div>
    }

    <!-- Meter already exists scenario -->
    @if (!fetchingMeterDetails && canShowMeterAlreadyExistsError()) {
      <div class="error-section">
        <div class="error-text">
          <mat-icon class="error-icon d-none d-sm-inline icon-no-shrink">error</mat-icon>
          <span class="text-error">
            @if (form.get('addressType')?.value === 'meterNo') {
              This meter is already added to your account. 
            } @else {
              All meters at this address are already added to your account.
            }
          </span>
        </div>
      </div>
    }

    <!-- No supported meters found scenario -->
    @if (!fetchingMeterDetails && canShowNoMetersError()) {
      <div class="error-section">
        <div class="error-text">
          <mat-icon class="error-icon d-none d-sm-inline icon-no-shrink">error</mat-icon>
          <span class="text-error">
            @if (meterDetails.length === 0) {
              @if (form.get('addressType')?.value === 'postcode') {
                No meters found. Try another address or use a meter number.
              } @else {
                No data found for this input. Please check the meter number and try again.
              }
            }
            @if (meterDetails.length > 0 && getSupportedMeters().length === 0) {
              No supported meters found. Only meters of the following types are supported: {{ supportedMeterTypes().join(', ') }}.
            }
          </span>
        </div>
      </div>
    }
  </div>
</div>
